import { ColumnDef } from "@tanstack/react-table";
import { formatDateAndTime } from "../../../helpers/appHelpers";
import { SalaryAdjustmentDto } from "../../../models/salary-adjustment.dto";
import {
	ADJUSTMENT_TYPE_LABELS,
	SalaryAdjustmentStatusBadge,
	formatAdjustmentPayPeriod,
	formatAdjustmentValue,
} from "./data";

/** Extra data passed to the table through its `meta` prop */
export type SalaryAdjustmentTableMeta = {
	payPeriodCodes: Record<number, string>;
};

export const salaryAdjustmentColumns: ColumnDef<SalaryAdjustmentDto>[] = [
	{
		id: "code",
		accessorKey: "code",
		header: "Code",
		size: 160,
	},
	{
		id: "name",
		accessorKey: "name",
		header: "Name",
		size: 220,
	},
	{
		id: "adjustmentType",
		accessorKey: "adjustmentType",
		header: "Type",
		size: 140,
		cell: ({ row }) =>
			ADJUSTMENT_TYPE_LABELS[row.original.adjustmentType] ||
			row.original.adjustmentType,
	},
	{
		id: "value",
		header: "Value",
		size: 160,
		cell: ({ row }) => formatAdjustmentValue(row.original),
	},
	{
		id: "payPeriod",
		header: "Pay Period",
		size: 180,
		cell: ({ row, table }) => {
			const meta = table.options.meta as SalaryAdjustmentTableMeta | undefined;
			return formatAdjustmentPayPeriod(row.original, meta?.payPeriodCodes);
		},
	},
	{
		id: "status",
		accessorKey: "status",
		header: "Status",
		size: 160,
		cell: ({ row }) => (
			<SalaryAdjustmentStatusBadge status={row.original.status} />
		),
	},
	{
		id: "description",
		accessorKey: "description",
		header: "Description",
		size: 300,
		cell: ({ row }) => row.original.description || "--",
	},
	{
		id: "createdAt",
		accessorKey: "createdAt",
		header: "Date Created",
		size: 200,
		cell: ({ row }) => formatDateAndTime(row.original.createdAt),
	},
];

export const salaryAdjustmentColumnVisibility: Record<string, boolean> = {
	code: true,
	name: true,
	adjustmentType: true,
	value: true,
	payPeriod: true,
	status: true,
	description: false,
	createdAt: true,
};
